var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#727981",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.25C10.5 8.6625 10.1625 9 9.75 9H3C2.5875 9 2.25 8.6625 2.25 8.25C2.25 7.8375 2.5875 7.5 3 7.5H9.75C10.1625 7.5 10.5 7.8375 10.5 8.25ZM2.25 5.25C2.25 5.6625 2.5875 6 3 6H9.75C10.1625 6 10.5 5.6625 10.5 5.25C10.5 4.8375 10.1625 4.5 9.75 4.5H3C2.5875 4.5 2.25 4.8375 2.25 5.25ZM7.5 11.25C7.5 10.8375 7.1625 10.5 6.75 10.5H3C2.5875 10.5 2.25 10.8375 2.25 11.25C2.25 11.6625 2.5875 12 3 12H6.75C7.1625 12 7.5 11.6625 7.5 11.25ZM13.5075 9.6525L14.04 9.12C14.3325 8.8275 14.805 8.8275 15.0975 9.12L15.63 9.6525C15.9225 9.945 15.9225 10.4175 15.63 10.71L15.0975 11.2425L13.5075 9.6525ZM12.975 10.185L9.105 14.055C9.0375 14.1225 9 14.2125 9 14.3175V15.375C9 15.585 9.165 15.75 9.375 15.75H10.4325C10.53 15.75 10.6275 15.7125 10.695 15.6375L14.565 11.7675L12.975 10.185Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.a32dabf3.svg";
export { ForwardRef as ReactComponent };